import { render } from "./Table.vue?vue&type=template&id=6103bc75"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
script.render = render

export default script